import axios from 'axios'
import {
    getUserRefreshToken,
    removeUserRefreshToken,
    removeUserToken,
    setUserRefreshToken
} from "../localStorage/LocalStorageService";
import {RouteHelper} from "../../route/RouteHelper";
import {readToken, writeNewToken} from "../authService/AuthService";
import {LoginService} from "../../serverService/login/LoginService";

export class HttpClient {

    constructor(
        customConfig = {},
        contentType = "application/json",
        baseUrl = process.env.REACT_APP_MANAGEMNET_BASE_URL
    ) {
        this.token = readToken()

        this.clientId = process.env.REACT_APP_CLIENT_ID
        this.clientSecret = process.env.REACT_APP_CLIENT_SECRET

        this.instance = axios.create({
                baseURL: baseUrl,
                ...customConfig,
            }
        )

        this.instance.interceptors.request.use(
            config => {
                if (this.token) {
                    config.headers['Authorization'] = this.convertToken(this.token);
                }
                config.headers['Content-Type'] = contentType;
                return config;
            },
            error => {
                throw error;
            });

        this.instance.interceptors.response.use(
            (response) => response,
            async function (error) {

                const originalRequest = error.config;

                if (error.response.status === 401 && originalRequest.url === process.env.REACT_APP_KECLOACK_URL) {
                    doLogoutUser()
                    throw error;
                }

                if (error.response.status === 401 && !originalRequest._retry) {

                    originalRequest._retry = true;

                    const refreshToken = getUserRefreshToken()

                    let response = null

                    try {

                        response = await new LoginService().getUserTokenByRefreshToken(refreshToken)

                        const _refreshToken = response.data.refresh_token
                        const _token = response.data.access_token

                        setUserRefreshToken(_refreshToken)
                        writeNewToken(_token)

                        originalRequest.headers.Authorization = `bearer ${_token}`

                        return axios(originalRequest)
                    } catch (e) {
                        doLogoutUser()
                    }

                } else if (error.response.status === 403) {
                    // throw error;
                    window.location.href = RouteHelper.NotAccess.url
                } else {
                    throw error;
                }

            },
        )
    }

    post(url, data = {}, header = {}, params = {}, signal) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'post',
                url: url,
                params: params,
                headers: header,
                data: data,
                signal
            }).then(response => resolve(response.data))
                .catch(reject)
        })
    }

    get(
        url, params = {}, header = {}, data = {}, cancelToken) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'get',
                url: url,
                data: data,
                params: params,
                headers: header,
                ...cancelToken
            }).then(response => {
                resolve(response.data)
            }).catch(reject)

        })
    }

    getData(
        url, data = {}) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'get',
                url: url,
                data: data,
            }).then(response => resolve(response.data))
                .catch(reject)
        })
    }

    getFile(
        url, header = {}, params = {}, data = {}) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'get',
                url: url,
                data: data,
                params: params,
                headers: header,
                responseType: "blob"
            }).then(response => {
                resolve(response.data)
            })
                .catch(reject)
        })
    }


    put(url, data = {}, header = {}, params = {}) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'put',
                url: url,
                params: params,
                headers: header,
                data: data
            }).then(response => resolve(response.data))
                .catch(reject)
        })
    }

    patch(url, header = {}, data = {}, params = {},signal) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'patch',
                url: url,
                params: params,
                headers: header,
                data: data,
                signal
            }).then(response => resolve(response.data))
                .catch(reject)
        })
    }

    delete(url, header = {}, data = {}, params = {}) {
        return new Promise((resolve, reject) => {
            this.instance({
                method: 'delete',
                url: url,
                params: params,
                headers: header,
                data: data
            }).then(response => resolve(response.data))
                .catch(reject)
        })
    }

    convertToken(token) {
        let _token = ""
        _token = "bearer " + token
        return _token
    }

    prepareUserAccessHeader(token) {
        return {
            "Authorization": this.convertToken(token),
        }
    }

    getClientId() {
        return this.clientId
    }

    getClientSecret() {
        return this.clientSecret
    }

}

function doLogoutUser() {
    removeUserToken()
    removeUserRefreshToken()
    window.location.href = RouteHelper.SignInEnterPhoneNumber.url
}